import { useState, useEffect } from 'react';
import { FiX, FiLogOut } from 'react-icons/fi';
import api from '../utils/api';
import { useAuth } from '../contexts/AuthContext';
import { getFcmToken } from '../utils/firebase';

export const Configurations = ({
  isShown,
  isIOS,
  isStandalone,
  visitorId,
  onShowIOSInstructions,
  onHideIOSInstructions,
  onClose,
}) => {
  const { logout } = useAuth();
  const [subscriptionActive, setSubscriptionActive] = useState(false);
  const [fcmToken, setFcmToken] = useState(null);
  
  useEffect(() => {
    console.log('useEffect', fcmToken, isShown);
    if (fcmToken || !isShown) {
      return;
    }

    (async () => {
      const token = await getFcmToken();
      console.log('const token = await getFcmToken();', token);
      setFcmToken(token);
    })();
  }, [fcmToken, isShown]);

  useEffect(() => {
    if (!fcmToken) {
      return;
    }

    (async () => {
      try {
        const response = await api.post(`/api/notify/status`, { fcmToken });
        console.log('response', response);
        
        if (response.data.success) {
          console.log('setSubscriptionActive(true);');
          setSubscriptionActive(true);
          console.log('✅ Push notifications validated successfully');
        } else {
          console.log('❌ Push notifications validated successfully', response.data);
        }
      } catch (error) {
        console.log('ℹ️ Push notifications not validated:', error.message);
      }
    })();
  }, [fcmToken]);

  console.log('Configurations fcmToken', fcmToken);

  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-gray-900">Notification Settings</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <FiX className="h-4 w-4" />
        </button>
      </div>
      
        <div className="space-y-3">
          <button
            onClick={() => {
              api.post('/api/notify');
              onClose();
            }}
            className="w-full inline-flex items-center justify-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Test notification
          </button>
          
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-700">Push Notifications</span>
            <label className="inline-flex items-center cursor-pointer">
              <input 
                type="checkbox" 
                checked={subscriptionActive} 
                className="sr-only peer" 
                onChange={async (e) => {
                  console.log('onChange fcmToken', fcmToken);
                  const originalValue = subscriptionActive;
                  try {
                    setSubscriptionActive(!originalValue);
                    await api.post('/api/notify/toggle', { fcmToken, active: !originalValue });
                  } catch (err) {
                    console.error('❌ Error toggling notifications:', err);
                    setSubscriptionActive(originalValue);
                  }
                }} 
              />
              <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
            </label>
          </div>

          {/* iOS Installation Instructions */}
          {isIOS && !isStandalone && (
            <div className="pt-3 border-t border-gray-200">
              <button
                onClick={onShowIOSInstructions}
                className="w-full inline-flex items-center justify-center px-3 py-2 border border-blue-300 shadow-sm text-sm leading-4 font-medium rounded-md text-blue-700 bg-blue-50 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                📱 Add to Home Screen
              </button>
            </div>
          )}

          {/* PWA Status */}
          <div className="pt-3 border-t border-gray-200">
            <div className="flex items-center justify-between text-xs text-gray-500">
              <span>App Status:</span>
              <span className={`font-medium ${isStandalone ? 'text-green-600' : 'text-orange-600'}`}>
                {isStandalone ? 'Installed' : 'Not Installed'}
              </span>
            </div>
            {isIOS && (
              <div className="flex items-center justify-between text-xs text-gray-500 mt-1">
                <span>Device:</span>
                <span className="font-medium text-blue-600">iOS</span>
              </div>
            )}
          </div>

          {/* Visitor ID */}
          <div className="pt-3 border-t border-gray-200">
            <div className="flex items-center justify-between text-xs text-gray-500">
              <span>Visitor ID:</span>
              <span className="font-medium text-purple-600 font-mono">
                {visitorId ? visitorId.substring(0, 8) + '...' : 'Loading...'}
              </span>
            </div>
            {visitorId && (
              <button
                onClick={() => {
                  navigator.clipboard.writeText(visitorId);
                  // You could add a toast notification here
                }}
                className="mt-1 w-full text-xs text-purple-600 hover:text-purple-800 underline"
                title="Click to copy full ID"
              >
                Copy full ID
              </button>
            )}
          </div>

          {/* Logout Button */}
          <div className="pt-3 border-t border-gray-200">
            <button
              onClick={() => {
                logout();
                onHideIOSInstructions();
              }}
              className="w-full inline-flex items-center justify-center px-3 py-2 border border-red-300 shadow-sm text-sm leading-4 font-medium rounded-md text-red-700 bg-red-50 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              <FiLogOut className="mr-2 h-4 w-4" />
              Sign Out
            </button>
          </div>
        </div>
    </div>
  )  
}